const CommonGroupStructure = {
    accUserId: "",
    groupList: [
        {
            groupid: "", // Unique Reel ID
            grouppic: "",
            createdOn: "",
            createdby: "",
            activelevel: "",
            category: "",      // public or private group
            nmembers: 0,
            members: [
                {
                    personid: "",
                    joinedon: "",
                    activelevel: "",
                    adminrights: "",
                    nmessages: 0,
                    nmedia: 0,  
                }
            ],
            totalmesg: "",
            messages: [
                {
                    messageid: "",
                    mediaattached: "",
                    senton: "",
                    pinned: 0, 
                    deleteflag: 0,
                }
            ],
            timetostore: "",
        }
    ]
};

export default CommonGroupStructure;
